var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "48px",
    height: "48px",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M24.22,5.37c-0.62-0.02-1.18,0.35-1.44,0.91l-1.47,3.19c-3.29,7.15-3.29,15.39,0,22.54l1.47,3.19 c0.26,0.56,0.82,0.92,1.44,0.91c12.79-0.34,23-7.09,23-15.37C47.22,12.46,37.01,5.71,24.22,5.37z M25.44,31.97l-0.7-1.53 c-2.83-6.16-2.83-13.24,0-19.39l0.71-1.54c0.08-0.18,0.27-0.29,0.47-0.28c9.65,0.78,17.54,5.84,17.54,11.51 c0,5.66-7.86,10.71-17.54,11.51C25.72,32.26,25.53,32.15,25.44,31.97z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.3,10.66L4.01,17.18c-1.03,0.55-2.31,0.15-2.85-0.87l-0.02-0.04c-0.55-1.03-0.15-2.31,0.87-2.85L14.31,6.9 c1.03-0.55,2.31-0.15,2.85,0.87l0.02,0.04C17.72,8.84,17.33,10.11,16.3,10.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.3,19.45L4.01,25.97c-1.03,0.55-2.31,0.15-2.85-0.87l-0.02-0.04c-0.55-1.03-0.15-2.31,0.87-2.85l12.29-6.52 c1.03-0.55,2.31-0.15,2.85,0.87l0.02,0.04C17.72,17.63,17.33,18.9,16.3,19.45z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.3,28.24L4.01,34.76c-1.03,0.55-2.31,0.15-2.85-0.87l-0.02-0.04C0.59,32.82,0.98,31.55,2.01,31l12.29-6.52 c1.03-0.55,2.31-0.15,2.85,0.87l0.02,0.04C17.72,26.42,17.33,27.69,16.3,28.24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.3,37.03L4.01,43.55c-1.03,0.55-2.31,0.15-2.85-0.87l-0.02-0.04c-0.55-1.03-0.15-2.31,0.87-2.85l12.29-6.52 c1.03-0.55,2.31-0.15,2.85,0.87l0.02,0.04C17.72,35.21,17.33,36.49,16.3,37.03z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg6);
export default __webpack_public_path__ + "static/media/6.fcc57c1f8252a65754a13ac05b9fee8f.svg";
export { ForwardRef as ReactComponent };